import { Star } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, Avatar, AvatarFallback, AvatarImage } from "@b2b/ui-components";

interface CustomerTestimonialsProps {
  testimonials?: any[];
}

const renderStars = (rating: number = 5) => {
  return Array.from({ length: 5 }, (_, i) => (
    <Star
      key={i}
      className={`h-4 w-4 ${i < Math.floor(rating)
          ? "fill-orange-600 text-orange-500"
          : "text-gray-500"
        }`}
    />
  ));
};

export const CustomerTestimonials = ({ testimonials }: CustomerTestimonialsProps) => {
  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  return (
    <Card className="mb-6 sm:mb-8 shadow-lg border-0">
      <CardHeader className="bg-gradient-to-r from-[#FF6A00]/5 to-[#FF6A00]/10 py-2">
        <CardTitle className="text-orange-500 text-lg sm:text-xl">
          Customer Testimonials
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 md:p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
          {testimonials.map((testimonial: any, index: number) => {
            const name = testimonial.customerName || testimonial.name || "Customer";
            const initials = name
              .split(" ")
              .map((n: string) => n[0])
              .join("")
              .substring(0, 2)
              .toUpperCase();

            return (
              <div
                key={testimonial.id || index}
                className="bg-white border rounded-xl p-4 sm:p-5 md:p-6 shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <Avatar className="h-10 w-10 sm:h-12 sm:w-12">
                    {testimonial.customerImageUrl || testimonial.avatar ? (
                      <AvatarImage src={testimonial.customerImageUrl || testimonial.avatar} />
                    ) : null}
                    <AvatarFallback className="bg-[#FF6A00]/10 text-[#FF6A00] text-xs sm:text-sm">
                      {initials}
                    </AvatarFallback>
                  </Avatar>
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-gray-900 text-sm sm:text-base truncate">
                      {name}
                    </div>
                    {testimonial.companyName && (
                      <div className="text-xs sm:text-sm text-gray-500 truncate">
                        {testimonial.companyName}
                      </div>
                    )}
                    {testimonial.country && (
                      <div className="text-xs text-gray-400">
                        {testimonial.country}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center mb-2 sm:mb-3">
                  {/* {renderStars(testimonial.rating || 5)} */}
                </div>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed italic">
                  "{testimonial.content || testimonial.text || testimonial.testimonial || "Great service!"}"
                </p>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};